import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import store, { loanActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { RefreshEvents } from '../../common/SharedEvents';
import { LoadPanel } from 'devextreme-react/load-panel';
import { CommonLoanSummary } from '../common/LoanComponents';
import { handleAdminError, handleAdminSuccess } from '../../common/SharedFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CommonLoanSummaryInvokingFeatureType } from '../common/constants/CommonLoanSummaryInvokingFeatureType';

const styles = {
    buttonMarginRight: { marginRight: '10px' },
    buttonContainer: {
        textAlign: 'right',
        borderTop: '2px solid silver',
        padding: '10px 10px',
    },
    form: { paddingLeft: '5px', paddingTop: '10px' },
    formRow: { marginBottom: '0' },
};

const RevertToApproved = () => {
    const { isOpen, loanId } = useSelector((state) => state.loan.revertToApprovedModal);
    const { dispatch } = store;

    const [loan, set_loan] = useState(null);
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');

    const loanApi = new LoanApi.LoanApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const _handleClose = () =>
        dispatch(
            loanActions.setRevertToApprovedModal({
                revertToApprovedModal: { isOpen: false },
            })
        );

    useEffect(() => {
        async function loanIdChanged() {
            if (loanId && loanId > 0) {
                await loadLoanInfo(loanId);
            } else {
                resetState();
            }
            set_loadingOpen(false);
        }

        loanIdChanged();
    }, [isOpen, loanId]);

    const resetState = () => {
        //set_id(0);
        set_loan(null);
    };

    const loadLoanInfo = async (id) => {
        set_loadingMessage('Loading...');
        set_loadingOpen(true);

        const response = await loanApi.getRevertToApproved(id);
        if (response.statusCode !== 200) {
            set_loadingOpen(false);
            return;
        }
        const loan = response.result;
        set_loan(loan);

        set_loadingOpen(false);
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        try {
            set_loadingMessage('Saving...');
            set_loadingOpen(true);

            const response = await loanApi.setRevertToApproved(loanId);
            if (response.statusCode !== 200) {
                set_loadingOpen(false);
                return;
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Loan reverted successfully and moved to Approved Status.');
            set_loadingOpen(false);

            setTimeout(() => {
                _handleClose();
            }, 600);
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    if (!isOpen || !loan) {
        return '';
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex={-1}
                            role='dialog'
                            style={{ width: '600px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <form
                                    name='loanLostForm'
                                    onSubmit={(event) => onSubmit(event)}
                                >
                                    <div>
                                        <div
                                            className='page-header'
                                            role='banner'
                                        >
                                            <h1 style={{ whiteSpace: 'nowrap' }}>Revert to Approved Status</h1>
                                            <button
                                                type='button'
                                                className='close'
                                                data-dismiss='modal'
                                                aria-label='Close'
                                                onClick={_handleClose}
                                            >
                                                <span aria-hidden='true'>&times;</span>
                                            </button>
                                        </div>
                                        <div>
                                            <div
                                                style={styles.form}
                                                className={'standard-form'}
                                            >
                                                <div
                                                    className='row'
                                                    style={styles.formRow}
                                                >
                                                    <div
                                                        className='columns small-12 large-12'
                                                        style={{
                                                            color: 'darkblue',
                                                            paddingBottom: '0',
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faInfoCircle} />
                                                        &nbsp;&nbsp;Reverting this loan to 'Approved' will clear the following
                                                        fields:
                                                        <ul>
                                                            <li>Note Date</li>
                                                            <li>Maturity Date</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <CommonLoanSummary
                                                    loan={loan}
                                                    invokingFeature={
                                                        CommonLoanSummaryInvokingFeatureType.RevertLoanToApprovedStatus
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div style={{ padding: '5px 5px' }}>
                                            <div
                                                className='button-footer'
                                                style={styles.buttonContainer}
                                            >
                                                <button
                                                    style={styles.buttonMarginRight}
                                                    type='submit'
                                                    className='button primary'
                                                >
                                                    Revert
                                                </button>
                                                <button
                                                    type='button'
                                                    className='button hollow'
                                                    data-dismiss='modal'
                                                    onClick={_handleClose}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};

export default RevertToApproved;
